var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsUUID } from 'class-validator';
export class UpdateUserIcd10Dto {
    /**
     * The ID of the patient.
     */
    userId;
    /**
     * The ID of the ICD-10 code for the diagnosis.
     */
    icd10Id;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UpdateUserIcd10Dto.prototype, "userId", void 0);
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], UpdateUserIcd10Dto.prototype, "icd10Id", void 0);
//# sourceMappingURL=update-user-icd10.dto.js.map